<h2 mat-dialog-title>New Texture</h2>
<mat-dialog-content>
    <form id="textureForm" (submit)="confirmAction()">
        <mat-form-field>
            <input
                [ngModel]="$result().width"
                (ngModelChange)="$result.set({...$result(), width: $event})"
                matInput
                type="number"
                [placeholder]="!$imperial() ? 'Width (cm)' : 'Width (in)'"
                name="textureWidth"
            />
        </mat-form-field>
        <mat-form-field>
            <input
                [ngModel]="$result().height"
                (ngModelChange)="$result.set({...$result(), height: $event})"
                matInput
                type="number"
                [placeholder]="!$imperial() ? 'Height (cm)' : 'Height (in)'"
                name="textureHeight"
            />
        </mat-form-field>
        <mat-form-field>
            <input
                [ngModel]="$result().displacement"
                (ngModelChange)="$result.set({...$result(), displacement: $event})"
                matInput
                type="number"
                [placeholder]="!$imperial() ? 'Displacement (cm)' : 'Displacement (in)'"
                name="textureDisplacement"
            />
        </mat-form-field>
        @if ($showColorSpaceSetting()) {
            <mat-form-field>
                <mat-select
                    [ngModel]="$result().colorSpace"
                    (ngModelChange)="$result.set({...$result(), colorSpace: $event})"
                    placeholder="Image file color space"
                    name="textureColorSpace"
                >
                    @for (imageColorspaceLabel of Labels.ImageColorSpace.values(); track imageColorspaceLabel.state) {
                        <mat-option [value]="imageColorspaceLabel.state">{{ imageColorspaceLabel.label }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelAction()">Cancel</button>
    <button mat-button form="textureForm" [disabled]="!$result().width || !$result().height || !$result().colorSpace">Create</button>
</mat-dialog-actions>
